import React, { useContext } from 'react';  
import { Outlet } from 'react-router-dom';  
import { LoginContext } from './common/App';
import { NavigateSmart } from './common/Common';
import { ConsumerContext } from '.';
import { MediationStatus } from './common/enums.mjs';


export const DataCollectedRoute = () => {
    const consumer = useContext(ConsumerContext);
    const login = useContext(LoginContext);


    return (
        !login.loggedIn ?
            null
        :
            consumer.mediationStatus === MediationStatus.NONE ?
                <NavigateSmart to="/collect_data/how_it_works/"/>
            :
                <Outlet />
    );
};

export default DataCollectedRoute
